<template>
  <div class="m-auto w-full max-w-[1080px] px-6 md:px-8">
    <slot />
  </div>
</template>
